import { convertKeysForObject } from '@/utils/parameter'

export default class BaseEntity {
  constructor(params) {
    Object.assign(this, convertKeysForObject(params))
  }
}
